var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "vertical-center w-100 px-5 py-3" },
      [
        _c("b-skeleton", { attrs: { width: "2.85rem", height: "2.85rem" } }),
        _vm._v(" "),
        _c("b-skeleton", {
          staticClass: "ml-4",
          attrs: { width: "100%", height: "2rem" },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "vertical-center w-100 px-5 py-3" },
      [_c("b-skeleton", { attrs: { width: "100%", height: "2rem" } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "vertical-center w-100 px-5 py-3" },
      [_c("b-skeleton", { attrs: { width: "100%", height: "20rem" } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }